const { getElement } = window.BAO.Utils

class PageDetails extends window.BAO.CustomElement({
  SuperClass: HTMLDetailsElement,
}) {
  static get requiredElements () {
    return ['summary', 'content']
  }

  constructor () {
    super()

    /**
     * @type {Animation|null}
     * @public
     */
    this.animation = null

    /**
     * @type {Boolean}
     * @public
     */
    this.isClosing = false

    /**
     * @type {Boolean}
     * @public
     */
    this.isExpanding = false
    window.BAO.accordionExpanding = false
    if (this.externalEls.container.exists) {
      this.externalEls.container.element.setAttribute(
        'data-expanding',
        String(window.BAO.accordionExpanding),
      )
    }
  }

  setupListeners () {
    super.setupListeners()

    this.onSummaryClick = this.onSummaryClick.bind(this)

    this.listeners.add(this, 'click', this.onSummaryClick)
  }

  /**
   * @param {MouseEvent} e
   *
   * @returns {void}
   */
  onSummaryClick (e) {
    const summaryEl = e.target.closest(this.els.summary.selector)
    const closeEl = e.target.closest(this.els?.close?.selector)

    if (!summaryEl && !closeEl) return

    if (window.BAO.accordionExpanding === true) return

    e.preventDefault()

    if (this.isClosing || !this.open) {
      this.start()
    } else if (this.isExpanding || this.open) {
      this.close()
    }

    if (this.externalEls.container.exists) {
      document
        .querySelectorAll(
          '[data-page-details-external-el="container"] details[open] summary',
        )
        .forEach(detailEl => {
          if (detailEl === summaryEl) return

          detailEl.click()
        })
    }
  }

  start () {
    this.open = true

    this.setAttribute('data-fully-open', 'false')
    window.requestAnimationFrame(() => this.expand())
  }

  close () {
    this.setAttribute('data-fully-open', 'false')
    this.shrink()
  }

  shrink () {
    this.isClosing = true

    if (this.animation) {
      this.animation.cancel()
    }

    this.animation = this.content.animate(
      this.animationConfiguration.in.keyframes,
      this.animationConfiguration.in.options,
    )

    this.animation.onfinish = () => this.onAnimationFinish(false)
    this.animation.oncancel = () => (this.isClosing = false)
  }

  expand () {
    this.isExpanding = true
    window.BAO.accordionExpanding = true
    if (this.externalEls.container.exists) {
      this.externalEls.container.element.setAttribute(
        'data-expanding',
        String(window.BAO.accordionExpanding),
      )
    }

    if (this.animation) {
      this.animation.cancel()
    }

    this.animation = this.content.animate(
      this.animationConfiguration.out.keyframes,
      this.animationConfiguration.out.options,
    )

    this.animation.onfinish = () => this.onAnimationFinish(true)
    this.animation.oncancel = () => {
      this.isExpanding = false
      window.BAO.accordionExpanding = false
      if (this.externalEls.container.exists) {
        this.externalEls.container.element.setAttribute(
          'data-expanding',
          String(window.BAO.accordionExpanding),
        )
      }
    }
  }

  /**
   * @param {Boolean} open
   *
   * @returns {void}
   */
  onAnimationFinish (open) {
    this.open = open
    this.animation = null

    this.isClosing = false
    this.isExpanding = false
    window.BAO.accordionExpanding = false
    if (this.externalEls.container.exists) {
      this.externalEls.container.element.setAttribute(
        'data-expanding',
        String(window.BAO.accordionExpanding),
      )
    }

    this.setAttribute('data-fully-open', String(open))
    getElement(this.els.summary.selector, { context: this })?.setAttribute(
      'aria-expanded',
      String(open),
    )

    if (this.externalEls.container.exists) {
      if (document.querySelector('details[open]') !== null) {
        this.externalEls.container.element.classList.add(
          'pg-Page_Content-detailsOpen',
        )
      } else {
        this.externalEls.container.element.classList.remove(
          'pg-Page_Content-detailsOpen',
        )
      }
    }
  }

  get content () {
    return window.BAO.Utils.getElement(this.els.content.selector, {
      context: this,
    })
  }

  get animationConfiguration () {
    return {
      in: {
        keyframes: {
          opacity: [1, 0],
          maxHeight: ['550px', '0px'],
        },
        options: { duration: 400, easing: 'ease' },
      },
      out: {
        keyframes: {
          opacity: [0, 1],
          maxHeight: ['0px', '550px'],
        },
        options: { duration: 400, easing: 'ease' },
      },
    }
  }
}

if (!customElements.get('page-details')) {
  customElements.define('page-details', PageDetails, { extends: 'details' })
}
